<div class="container-local">
  <div class="child-content">
    <h4 class="padding-bottom--2x">{{displayName()}}</h4>
    @if(!editCreatives) {
      <creative-details-row
        label="Leveranssätt"
        [value]="convertCreativeTypes(creative?.creative_type)"
      ></creative-details-row>
    }
    @if(isVideo && !editCreatives) {
      <creative-details-row
        label="Längd"
        [value]="(creative?.length | dashAsDefault) + ' s'"
      ></creative-details-row>
    }
    <creative-details-row
      label="Segment"
      [value]="getMergedSegmentDates()"
    ></creative-details-row>
    <creative-details-row
      label="Status"
      [useChildElement]="true">
      <creative-status-label [status]="creative?.status"></creative-status-label>
    </creative-details-row>
    @if(!editCreatives) {
      <creative-details-row
        label="Namn"
        [value]="creative?.custom_name | dashAsDefault"
      ></creative-details-row>
    }
    @if(isVideo && !editCreatives) {
      <creative-details-row
        label="Filmkod"
        [value]="creative?.video_code | dashAsDefault"
      ></creative-details-row>
    }
    @if(!editCreatives) {
      <creative-details-row
        [label]="isVideo ? 'Video-URL' : 'Bild-URL'"
        [value]="creative?.asset_url | dashAsDefault"
      ></creative-details-row>
      <creative-details-row
        label="Destinations-URL"
        [value]="creative?.destination_url | dashAsDefault"
      ></creative-details-row>
    }
    @if(isVideo && !editCreatives) {
      <creative-details-row
        label="Tracking-URL (klick)"
        [value]="creative?.click_tracking_url | dashAsDefault"
      ></creative-details-row>
    }
    @if(!editCreatives) {
      <creative-details-row
        label="Tracking-URL (impressions)"
        [value]="creative?.impression_tracking_urls?.length > 0 ? creative?.impression_tracking_urls : '' | dashAsDefault"
      ></creative-details-row>
      <creative-details-row
        label="Kommentar"
        [value]="creative?.custom_text | dashAsDefault"
      ></creative-details-row>
    }
  </div>
  <div>
    @if(!(isImage && editCreatives)) {
      <div class="asset-container asset-size margin-left--2x margin-bottom--1x float--right">
        @if(creative?.asset_url && isVideo) { <video [src]="creative?.asset_url" class="asset-size" controls></video> }
        @else if(creative?.asset_url && isImage) { <img [src]="creative?.asset_url" class="asset-size" /> }
        @else {
          <div class="creative--placeholder asset-size flex__container--vertical">
            <span class="icon icon-ios text--xl text--muted margin-bottom--1x"></span>
            Material saknas
          </div>
        }
      </div>
    }
  </div>
</div>

@if(editCreatives && creative.creative_type !== ImageCreativeType.pauseImage) {
  <instream-creative-form
    [creative]="creative"
    [creativeLengths]="[creative?.length]"
    [customerId]="customerId"
    [layoutProfile]="instreamCreativeFormProfile"
    [ongoingCreative]="ongoingCreative"
    [disableAG]="disableAG"
    [productFormatConditions]="productFormatConditions"
    (onChange)="creativeChange($event)"
    (onValidityChange)="creativeValidityChange($event)"
    >
  </instream-creative-form>
}
@if(editCreatives && creative.creative_type === ImageCreativeType.pauseImage) {
  <pause-creative-form
    class="display--block"
    [creative]="creative"
    [customerId]="customerId"
    [layoutProfile]="pauseCreativeFormProfile"
    (onChange)="creativeChange($event)"
    (onValidityChange)="creativeValidityChange($event)"
  ></pause-creative-form>
}
